import {
  CHANGE_ORDER_TASKS_LOAD_SUCCESS,
  CHANGE_ORDER_TASKS_SHOW_MODAL_SET,
  CHANGE_ORDER_TASKS_ADD,
  CHANGE_ORDER_TASKS_UPDATE,
  CHANGE_ORDER_TASK_DELETE,
} from 'components/admin/work-orders/details/change-order-tasks/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { changeOrderTasksApi } from 'services/api/change-order-tasks-api';

export function loadChangeOrderTasksRequest(workOrderId) {
  return (dispatch) => {
    return changeOrderTasksApi
      .getChangeOrderTasks(workOrderId)
      .then((response) => {
        if (response.ok) {
          dispatch(loadChangeOrderTasksSuccess(response.changeOrderTasks));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadChangeOrderTasksSuccess(changeOrderTasks) {
  return {
    type: CHANGE_ORDER_TASKS_LOAD_SUCCESS,
    payload: changeOrderTasks,
  };
}

export function setShowChangeOrderTaskModal() {
  return {
    type: CHANGE_ORDER_TASKS_SHOW_MODAL_SET,
  };
}

export function createChangeOrderTask(taskId, values) {
  return (dispatch) => {
    return changeOrderTasksApi
      .createChangeOrderTask(taskId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowChangeOrderTaskModal());
          dispatch(addChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function editChangeOrderTask(changeOrderTaskId, values) {
  return (dispatch) => {
    return changeOrderTasksApi
      .updateChangeOrderTask(changeOrderTaskId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowChangeOrderTaskModal());
          dispatch(updateChangeOrderTask(response.changeOrderTask));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function deleteChangeOrderTask(changeOrderTaskId) {
  return (dispatch) => {
    return changeOrderTasksApi
      .deleteChangeOrderTask(changeOrderTaskId)
      .then((response) => {
        if (response.ok) {
          dispatch(removeChangeOrderTask(changeOrderTaskId));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
        return response;
      });
  };
}

export function addChangeOrderTask(changeOrderTask) {
  return {
    type: CHANGE_ORDER_TASKS_ADD,
    payload: changeOrderTask,
  };
}

export function updateChangeOrderTask(changeOrderTask) {
  return {
    type: CHANGE_ORDER_TASKS_UPDATE,
    payload: changeOrderTask,
  };
}

export function removeChangeOrderTask(changeOrderTaskId) {
  return {
    type: CHANGE_ORDER_TASK_DELETE,
    payload: changeOrderTaskId,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-tasks/store/actions.js